export function isConfigYes(value: unknown): boolean {
  if (value === true || value === 1) {
    return true;
  }
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "yes" || normalized === "true" || normalized === "1";
  }
  return false;
}

/**
 * The tenant's default GST rate as a FRACTION (0.15 for 15%), read from the global
 * config the way GET /v6/config serves it.
 *
 * The row is config_function `global`, config_variable `global_GST_rate`, value
 * `0.1500`: legacy's "default GST Calculation rate .125 in case of 12.5"
 * (mod_global/global_config.inc:149). The API strips the `global_` prefix and keeps
 * the case (aeronet-fast-api app/config/schemas.py Config.validate_variable), so the
 * key is `GST_rate`. `gst_rate` is read as well because the backend's own lookup is
 * case-insensitive (app/config/crud.py get_config_value).
 *
 * Never fall back to `gst_list` ("0.1500:15.00", served as {"0.1500": "15.00"}): its
 * values are the display PERCENT, and reading one as the rate billed GST at 15 × the
 * subtotal on the work order reports. A missing or unreadable rate is 0, not a guess.
 */
export function globalGstRate(
  globalConfig?: { [key: string]: unknown } | null
): number {
  const raw = globalConfig?.GST_rate ?? globalConfig?.gst_rate;
  const rate = Number.parseFloat(String(raw ?? ""));
  return Number.isFinite(rate) && rate > 0 ? rate : 0;
}

/**
 * The tenant's default GST rate the way a company's Tax rate field holds it: the
 * gst_list key ("0.1500"), so the field opens on that option. "" when the tenant
 * has no readable rate, which leaves the default to the backend.
 *
 * TICKET-23113: the new-company form read `globalConfig.gst_rate` (served as
 * `GST_rate`), always fell back to "15", and opened on no option at all.
 */
export function globalGstRateKey(
  globalConfig?: { [key: string]: unknown } | null
): string {
  const raw = globalConfig?.GST_rate ?? globalConfig?.gst_rate;
  const rate = Number.parseFloat(String(raw ?? ""));
  return Number.isFinite(rate) && rate >= 0 && rate < 1 ? rate.toFixed(4) : "";
}
